import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class DocLocalService {
  docArray = [];
  constructor() {}
  saveDocArray(doc) {
    this.docArray = doc;
  }
  getDocArray() {
    return this.docArray;
  }
}
